export default __webpack_public_path__ + "static/media/wine-group.abcf4744.svg";